var path = 'app/core/analytics2/chart.html';
var html = "<div id=\"{{chartId}}\" class=\"chart\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;